import React, { Component } from 'react'

class AddTodo extends Component {
  state = {
    todoText: ""
  }
  
  //w/o changeTodo u will not able to see whatevr u wrt inside input tag
  changeTodo = (e) => {
    this.setState({
      todoText: e.target.value
    });
  };

  //onSubmit triggers both the event in one; ie. input change & submit buttn
  SubmitHandler = (e) => {
    e.preventDefault();
    this.props.addTodoState(this.state.todoText);
    this.setState({
      todoText: ""
    });
  };


  render() {
    return (
      <>
        <form className="ui form" 
        onSubmit={this.SubmitHandler}
        >
          <div className="ui left icon input">
            &nbsp;&nbsp;&nbsp;
            <input
            type="text"
            placeholder="Enter Todo Items"
            onChange={this.changeTodo} 
            value={this.state.todoText}
            />
            <i className="pencil alternate icon"></i>
          <button
          type="submit"
          className="ui inverted purple button">
            Add Todo
          </button>
          </div>
        </form><br/>
      </>
    )
  }
}

export default AddTodo;
